import { StreamData } from "../interfaces/StreamData";

export function asArray<T>(value: T | T[]): T[] {
  return Array.isArray(value) ? value : [value];
}

export function tap<T>(value: T, action: (value: T) => void): T {
  action(value);

  return value;
}

export function sourcesEqual(source1: StreamData, source2: StreamData): boolean {
  return source1.src === source2.src && source1.type === source2.type;
}
